import React, { useContext, useState } from "react";
import styled, { css } from "styled-components";
import Accordion from "@motorata/base-ui.components.molecules.accordion";
import Button, { IconButton } from "@motorata/base-ui.components.atoms.button";
import { Box, Row } from "@motorata/base-ui.components.atoms._atoms";
import {
  BRANDS_ARRAY, BRANDS_MOTO_ARRAY, MODELS_ARRAY, PRICE_ARRAY
} from "@motorata/base-ui.data";
import { LabelH2 } from "@motorata/base-ui.components.atoms.typography";
import Select, { RangeSelect } from "@motorata/base-ui.components.atoms.select";
import MotoUpCalculatorBlock from "../../components/shared/MotoUpCalculatorBlock";
import { FilterContext } from "@/providers/FilterProvider";
import FiltersComponents from "@/components/shared/FiltersComponents";

const OffersSideBar = () => {
  const [showFilters, setShowFilters] = useState(false);
  const { filters, onChange } = useContext(FilterContext)

  return (
    <>
      <Box>
        <Wrapper active={showFilters}>
          <Row padding="S" justifyContent="space-between" className="responsive mobile">
            <LabelH2 margin="0">Filtruj ogłoszenia</LabelH2>
            <IconButton icon="close" onClick={() => setShowFilters(false)} />
          </Row>
          <Accordion padding="0px" wrapperProps={{ marginBottom: "S" }}>
            <Box>
              <Select
                name="brand"
                label="Marka"
                background="white"
                value={filters.brand}
                onChange={(e) => onChange(e)}
                shrink={!!filters.brand}
                options={filters.productType === "motorbikes" ? BRANDS_MOTO_ARRAY : BRANDS_ARRAY}
              />
            </Box>
            {
              (filters.productType === "all" || filters.productType === "car") &&
              <Box>
                <Select
                  name="model"
                  label="Model"
                  background="white"
                  value={filters.model}
                  shrink={!!filters.model}
                  onChange={(e) => onChange(e)}
                  options={MODELS_ARRAY[filters.brand] ?? []}
                />
              </Box>
            }
          </Accordion>
          <Accordion title="Dodatkowe informacje" wrapperProps={{ marginBottom: "S" }}>
            <RangeSelect
              name="price"
              label="Wartość przedmiotu"
              value={filters.price}
              labels={["Cena od", "Cena do"]}
              onChange={(e) => onChange(e)}
              shrink={[!!filters.price[0], !!filters.price[1]]}
              options={[PRICE_ARRAY, PRICE_ARRAY]}
              marginBottom="S"
            />
            <FiltersComponents onChange={onChange} />
          </Accordion>
          <ButtonWrapper>
            <Button width="100%" onClick={() => setShowFilters(false)}>
              Szukaj ofert
            </Button>
          </ButtonWrapper>
        </Wrapper>
        <StyledButton icon="filters" width="100%" onClick={() => setShowFilters(true)}>
          Filtruj ogłoszenia
        </StyledButton>
        <MotoUpCalculatorBlock />
      </Box>
    </>
  );
};

export default OffersSideBar;

const StyledButton = styled(Button)`
  display: none !important;
  position: fixed !important;
  bottom: 70px !important;
  left: 20px !important;
  width: calc(100% - 40px) !important;
  border-radius: 50px !important;
  z-index: 3 !important;

  @media (max-width: 1200px) {
    display: flex !important;
    justify-content: center;
  }
`;

const StyledRadioWrapper = styled(Box)`
  margin-bottom: 10px;

  @media (max-width: 1200px) {
    padding: 0 20px;
  }
`;

const Wrapper = styled(Box)<{
  active: boolean
}>`
  .responsive {
    display: none;
  }

  @media (max-width: 1200px) {
    position: fixed;
    width: 100vw;
    height: 100%;
    left: 0;
    top: 100%;
    opacity: 0;
    background: white;
    z-index: 999;
    transition: opacity 0.3s, top 0.3s;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      display: none;
    }

    .mobile {
      display: flex;
    }

    ${({ active }) =>
            active &&
            css`
              opacity: 1;
              top: 0;
            `}
  }
`;

const ButtonWrapper = styled(Box)`
  padding: 20px;
  padding-top: 0;
  display: none;
  position: sticky;
  bottom: 0;

  @media (max-width: 1200px) {
    display: block;
  }
`;
